import { render } from "./MyGroupBuys.vue?vue&type=template&id=044e72a7&scoped=true"
import script from "./MyGroupBuys.vue?vue&type=script&lang=js"
export * from "./MyGroupBuys.vue?vue&type=script&lang=js"

import "./MyGroupBuys.vue?vue&type=style&index=0&id=044e72a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044e72a7"]])

export default __exports__